import React, { useEffect } from 'react'
import CenterStage from '../../Components/CenterStage/CenterStage';
import imaStage from '../../assets/AnnualReport/StageImage.jpg'
import FeatureCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import imgMark from '../../assets/check-circle.svg'
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import FullImageCarousel from '../../Components/FullImageCarousel/FullImageCarousel';
import ima360Hydraulics from '../../assets/AnnualReport/Hydraulics360.jpg'
import ImageDescription from '../../Components/ImageDescription/ImageDescription';
import imaContinentsMap from '../../assets/AnnualReport/continentsMap.png'
import TextCaption from '../../Components/TextCaption/TextCaption';
import imaGraph1 from '../../assets/AnnualReport/graph1.png'
import imaGraph2 from '../../assets/AnnualReport/graph2.png'
import imaGraph3 from '../../assets/AnnualReport/graph3.png'
import imaGraphPT from '../../assets/AnnualReport/Graph PT.jpg'
import ImageText from '../../Components/ImageText/ImageText';
import imaBottonCard from '../../assets/AnnualReport/bottomCard.jpg'


const AnnualReport = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const featuresData = [
        {
            title: "5,152",
            description: "Employees",
            image: imgMark,
            model: 2
        },
        {
            title: "463",
            description: "Branches",
            image: imgMark,
            model: 2
        },
        {
            title: "400",
            description: "Service vehicles",
            image: imgMark,
            model: 2
        },
        {
            title: "40",
            description: "Countries",
            image: imgMark,
            model: 2
        },
    ]
    const featuresData2 = [
        {
            title: "638 million euros",
            description: "Sales (Group, consolidated)",
            image: imgMark,
            model: 2
        },
        {
            title: "< 22.1%",
            description: "Risk ratio",
            image: imgMark,
            model: 2
        },
        {
            title: "86,580",
            description: "Hydraulic emergency service operations",
            image: imgMark,
            model: 2
        },
    ]

    const carouselData = [
        {
            imageSrc: ima360Hydraulics,
            title: '360° HYDRAULICS',
            subtitle: 'HANSA-FLEX offers a 360° full service for the planning, operation and optimization of mobile and stationary hydraulic systems. Our customers from all industries and sizes receive the entire range of hydraulics from us at all times:',
            listItems: ["Production of hose lines and hose management", "Repairs, Maintenance and servicing for mobile and stationary hydraulics", "Assembly services", "Spare parts trade - online and stationary", "OEM equipment, series production, production plants", "Product development & manufacturing", "Logistics and services", "Planning and technical conception", "Training, technical advice, quality assurance", "Environmentally sound disposal of old hose lines"],
        },
    ]

    const carouselData2 = [
        {
            imageSrc: imaBottonCard,
            title: 'The HANSA-FLEX ANNUAL REPORTS',
            subtitle: 'Here you can download all annual reports from 2017 to 2022.',
            model: 2,
            listItems: [
                {
                    text: "Annual Report 2023",
                    link: "/PDF_folder/AnnualReport/2023.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2022",
                    link: "/PDF_folder/AnnualReport/2022.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2021",
                    link: "/PDF_folder/AnnualReport/2021.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2020",
                    link: "/PDF_folder/AnnualReport/2020.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2019",
                    link: "/PDF_folder/AnnualReport/2019.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2018",
                    link: "/PDF_folder/AnnualReport/2018.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2017",
                    link: "/PDF_folder/AnnualReport/2017.pdf"  // Will be detected as PDF link
                },
            ]
        },
    ]

    return (
        <div>
            <CenterStage title={"HANSA-FLEX AT A GLANCE"}
                paragraph={"HANSA-FLEX is a global family business and one of the world's leading system partners for fluid technology. In the past financial year, we generated sales of around 570 million euros with over 5,000 employees in 40 countries. The 2023 financial year and the key facts about HANSA-FLEX AG summarized in just a few pages: Our annual report offers a quick insight and many compact graphics."}
                imageSrc={imaStage} />

            <div className='div-gray'>
                <SectionHeader title={"HANSA-FLEX IN FIGURES"}
                    subtitle={"Here you will find the most important facts and figures about HANSA-FLEX AG from the 2023 financial year."} />
                <FeatureCardCarousel featuresData={featuresData} />
            </div>
            <FeatureCardCarousel featuresData={featuresData2} />

            <FullImageCarousel carouselItems={carouselData} />

            <SectionHeader title={"AT HOME ON EVERY CONTINENT"}
                subtitle={"The HANSA-FLEX locations"}
            />
            <ImageDescription
                imageSrc={imaContinentsMap}
            />
            <TextCaption title={"40 countries with 463 locations"}
                paragraph={"In addition to our own locations, we work with established partners in many other countries and deliver our goods almost anywhere you want."}
                buttonName={"BRANCH SEARCH"}
                buttonLink={"/"}
            />
            <br /><br />

            <div className='div-gray'>
                <SectionHeader title={"SALES DEVELOPMENT OF THE HANSA-FLEX GROUP 2019-2023"} />
                <ImageDescription
                    imageSrc={imaGraph1}
                />
                <ImageDescription
                    imageSrc={imaGraph2}
                />
                <TextCaption
                    paragraph={"Group consolidated (red), HANSA-FLEX Germany (unconsolidated, light grey), International HANSA-FLEX companies (unconsolidated, dark grey)"}
                />
                <br />
            </div>

            <SectionHeader title={"SALES SHARE BY PRODUCTS GROUP AND GLOBAL SALES DISTRIBUTION"}
                subtitle={"Sales distribution unconsolidated"}
            />
            <ImageDescription imageSrc={imaGraphPT} />

            <div className='div-gray'>
                <FullImageCarousel carouselItems={carouselData2} />
            </div>
        </div>
    )
}

export default AnnualReport